module.exports = "<p>TESTE BASICO IMPORTAR LICITAÇÔES</p>\r\n\r\n<button (click)=\"importBiddings()\">LISTAR LICITAÇÔES</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/new-biddings/new-biddings.component.html
// module id = ./src/app/pages/new-biddings/new-biddings.component.html
// module chunks = main